module.exports = __webpack_public_path__ + "static/media/slideshow-foto-05.b394ce65.png";